<template>
  <div>
    <div id="warning-message"><div style="
  top: 50%;
  margin-top: -5%;
  height: 10%;
  width: 100%;
  position: absolute;
  color: white;
  font-weight: bold;
  font-size: 20px;
">화면을 가로로 돌려주세요.</div></div>
    <section id="workspace" class="workspace__outer">

      <header-template
        ref="header"
        :userType="getCookie('userType')"
        v-on:call_canvas_sound="transmitCallCanvasSound"
        :type="gameType"
        :is-jb="isJb"
      ></header-template>

      <div class="workspace__inner">
        <canvas-template
          ref="gamecanvas"
          v-on:call_canvas_speed="transmitCallCanvasSpeed"
          v-on:call_save_log="transmitSaveLog"
          v-on:call_next_mission="transmitNextMission"
          v-on:update_clear_status="updateClearStatus"
          v-on:canvas_start="statusOn"
          v-on:canvas_stop="statusOff"
          v-bind:course_cat="cat1"
          v-bind:map_cat="cat2"
          v-bind:stage_cat="cat3"
          v-bind:mission_cat="cat4"
          v-bind:setup_data="setupData"

          @getBlockCount="setBlockCount"
          :studyModalVue="$refs.studyModal"
          :type="gameType"
          v-on:loading_done="closeLoadingTemplate"
        ></canvas-template>

        <workspace-template
          ref="workspace"
          v-on:call_canvas_init="transmitCallCanvasInit"
          v-on:call_blockly_save="transmitWorkspaceCodeSave"
          v-on:call_blockly_load="transmitWorkspaceCodeLoad"
          v-bind:contents_data="contentsData"
          v-bind:on_game="isOnGame"
          v-bind:setup_data="setupData"
          v-bind:block_data="blockData"
          :is-jb="isJb"

          :studyModalVue="$refs.studyModal"
          :blckNotAssmbl="blckNotAssmbl"
        ></workspace-template>
      </div>

      <loading-template
        ref="loading"
        v-if="isLoading"
      ></loading-template>
    </section>

    <stage-modal-template
      ref="studyModal"
      :type="gameType"
      :cat="cat"
      :is-jb="isJb"
      @onload="isModalLoading = true"
      @cancel="modalCallback"
      @confirm="modalCallback"></stage-modal-template>
  </div>
</template>

<script>

  /** NPM Module **/
  require('@fortawesome/fontawesome-free');

  import { axios, was } from '@/lib/axios';
  import mobileDetect from 'mobile-detect'

  import headerTemplate from './stage/StagePartialHeader'
  import loadingTemplate from './stage/StagePartialLoading'
  import canvasTemplate from './stage/StagePartialCanvas'
  import workspaceTemplate from './stage/StagePartialWorkspace'
  import stageModalTemplate from './stage/StagePartialModal'

  const BROWSER_TYPE = navigator.userAgent.toLowerCase();
  let gaScript;
  if (
    BROWSER_TYPE.indexOf('msie 10.0') > -1 // IE 10
    || BROWSER_TYPE.indexOf('msie 9.0') > -1 // IE 9
    || BROWSER_TYPE.indexOf('msie 8.0') > -1 // IE 8
    || BROWSER_TYPE.indexOf('msie 7.0') > -1 // IE 7
  ) gaScript = require('../../static/assets/js/utility/googleanalytics-ie10')
  else gaScript = require('../../static/assets/js/utility/googleanalytics')

  let cmpList;
  if(window.NODE_ENV === 'production' && window.NODE_REL === 'release'){
    cmpList = {
      'header-template': headerTemplate,
      'loading-template': loadingTemplate,
      'canvas-template': canvasTemplate,
      'workspace-template': workspaceTemplate,
      stageModalTemplate,
      gaScript
    };
  }else{
    cmpList = {
      'header-template': headerTemplate,
      'loading-template': loadingTemplate,
      'canvas-template': canvasTemplate,
      'workspace-template': workspaceTemplate,
      stageModalTemplate
    };
  }

  export default {
    name: 'CodmosMission',
    components: {
      'header-template': headerTemplate,
      'loading-template': loadingTemplate,
      'canvas-template': canvasTemplate,
      'workspace-template': workspaceTemplate,
      stageModalTemplate
    },
    data () {
      return {
        // [#] 상태 관련
        cat1: null,
        cat2: null,
        cat3: null,
        cat4: null,
        clearCheck: false,
        isLoading: true,
        isOnGame: false,

        // [#] stage 관련
        stageSubMeta:[],

        // [#] studyinfo 관련
        arrStudyInfo: {}, // 학습 정보 캐시
        studyMetaId: null, // StudyMeta ID
        studyMetaName : '', // StudyMeta name
        studyInfoId: null, // StudyInfo ID
        studyInfoVersion: null, // StudyInfo Version
        studyInfoType : 'block', // StudyInfo Type
        contentsData: null, // 캔버스 구성 데이터
        setupData: null, // 텍스트 구성 데이터
        blockData: null, // 블록 구성 데이터

        // [#] preference 관련
        userPrefId : null,
        userPrefDummy : { sound: 'Y', speed: 1, lang: 'ko', volume: 1 },
        missionPrefId : null,
        missionPrefDummy : {},
        studyInfoSaveLink: "/api/free/study/save_record",
        trialUserId: '',

        // 모달 관련
        isModalLoading: false,
        modalEvent: null,

        concept: {
          '1': '순차',
          '2': '반복',
          '3': '선택',
          '4': '변수'
        },

        gameType: 'gridLib',

        blckNotAssmbl: false,
        isJb: !window.location.pathname.split('/').pop().indexOf('ESOF03'),

        userType: this.$route.query.type === 'trial' ? 'party' : 'convert'
      }
    },
    methods : {
      /**
       * [ Function :: requestStageMeta ]
       *
       * @DES ::
       * @IP1 ::
       * @O.P ::
       * @S.E ::
       */
      requestStageMeta (cat1, cat2, cat3, cb) {
        axios.get(`${this.API_SERVER_URL}/manage/codmos/metas/findByCat?cat1=${this.cat1}&cat2=${this.cat2}&cat3=${this.cat3}&cat4=0&${this.randomId()}`)
          .then((response) => {
            if (
              typeof response.data.metas !== 'undefined'
              &&
              response.data.metas.length > 0
            ) {
              // 연결성공!
              cb(response.data.metas[0]);
            } else {
              // 노데이터!
              alert('스테이지 데이터가 존재하지 않습니다.');
            }
          })
          .catch((err) => {
            alert('[1] 데이터 조회중 문제가 발생했습니다.<br>관리자에게 문의해주세요.');
          });
      },
      /**
       * [ Function :: requestStudyInfo ]
       *
       * @DES :: 학습정보를 요청합니다.
       * @IP1 :: cat1 {str}
       * @IP2 :: cat2 {str}
       * @IP3 :: cat3 {str}
       * @IP4 :: cat4 {str}
       * @O.P :: callback
       * @S.E ::
       */
      requestStudyInfo(cat1, cat2, cat3, cat4, isNext) {
        return new Promise ((resolve, reject) => {
          axios.get(`${this.API_SERVER_URL}/manage/codmos/metas/findByCat?cat1=${this.cat1}&cat2=${this.cat2}&cat3=${this.cat3}&cat4=${this.cat4}&${this.randomId()}`)
            .then((response) => {
              if (
                typeof response.data.metas !== 'undefined'
                &&
                response.data.metas.length > 0
              ) {
                // 연결성공!
                resolve({
                  err: undefined,
                  data: response.data.metas[0]
                });
              } else {
                if (this.cat4 < this.stageSubMeta.length) {
                  // 노데이터!
                  alert('미션 데이터가 존재하지 않습니다.');
                  resolve({
                    err: undefined,
                    data: {}
                  });
                } else {
                  // 범주를 벗어남 => 맵으로 이동
                  window.close();
                }
              }
            })
            .catch(err => {
              // console.error(err);
              if (isNext) {
                window.opener.location.reload();    // 오프너(ESOP 플랫폼 웹페이지) 강제 갱신 처리
                window.close();                     // 사전교육 학습창 닫기
              } else {
                alert('[2] 데이터 조회중 문제가 발생했습니다.<br>관리자에게 문의해주세요.');
                resolve({
                  err: err,
                  data: undefined
                });
              }
            });
        });
      },
      /**
       * [ Function ::  ]
       *
       * @DES ::
       * @IP1 ::
       * @O.P ::
       * @S.E ::
       */
      requestUserStudyLog(isCleared) {
        return new Promise((resolve) => {
          const PUBLIC_IP = this.getCookie('publicIP') || '127.0.0.1';

          // [#] 시간관련 데이터 정리
          this.$refs.gamecanvas.getClearTime((START_TIME, SETTING_TIME, RUNNING_TIME) => {
            // [#] 블록자동저장 (성공시에) /  Map에 전달할 성공여부값
            const BLOCKLY_TEXT = Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(Blockly.mainWorkspace));
            if(isCleared === "Y") {
              this.$refs.workspace.blocklyText = BLOCKLY_TEXT;
              this.transmitWorkspaceCodeSave(false);
            }

            this.$refs.workspace.getUsedBlockCount(blockCount => {
              let lbcookie = document.cookie;
              if (this.userType === 'party') lbcookie = this.getLbparty(this.cat1);

              axios.post(
                `${this.API_SERVER_URL}/manage/codmos/record/${this.userType}/${this.cat1}/${this.cat2}/${this.cat3}/${this.cat4}`,
                {
                  isCleared: isCleared,
                  usedBlockCount: blockCount,
                  goalBlockCount: parseInt(this.$refs.workspace.maxWorkCount),
                  startTime: START_TIME.toJSON(),
                  settingTime: SETTING_TIME,
                  runningTime: RUNNING_TIME,
                  concept: this.concept[this.cat3],
                  publicIP: PUBLIC_IP
                },
                {
                  headers: {
                    lbcookie
                  }
                }).then((res) => {
                  resolve(res.data.code);
                });
            })
          });
        })
      },
      /**
       *  @DESC   하나의 미션을 해결하고 재시작 하는 경우에 아이템이 계속 획득되는 것을 방지하기 위해 클리어 처리
       */
      updateClearStatus() {
        this.clearCheck = true;
      },
      /**
       *  @DESC   로딩 템플릿 닫기
       */
      closeLoadingTemplate() {
        // # Cover Off
        $('#loading-cover').animate(
          {opacity: 0},
          {
            duration: 334,
            queue: false,
            complete: () => {
              this.isLoading = false;
            }
          });
      },
      /**
       *  @DESC   캔버스 초기화 요청 전달
       */
      transmitCallCanvasInit() {
        this.$refs.gamecanvas.restartCanvas();
      },
      /**
       *  @DESC   캔버스 스피트 요청 전달
       */
      transmitCallCanvasSpeed() {
        // [#] db speed status
        this.userPrefDummy.speed = this.$refs.gamecanvas.canvasDefaultSpeed = this.$refs.gamecanvas.gameSpeed;
      },
      /**
       *  @DESC   캔버스 사운드 요청 전달
       */
      transmitCallCanvasSound() {

        // [#] canvas mute status
        this.$refs.gamecanvas.canvasController.toggleSound();

        // [#] db mute status
        if(this.$refs.header.soundEnable) {
          this.userPrefDummy.sound = 'Y';
          window.LC_VOLUME = this.userPrefDummy.volume = 1;
          this.$refs.gamecanvas.canvasDefaultMute = false;
        }
        else {
          this.userPrefDummy.sound = 'N';
          window.LC_VOLUME = this.userPrefDummy.volume = 0;
          this.$refs.gamecanvas.canvasDefaultMute = true;
        }
      },
      /**
       *  @DESC   미션 preference 정보 저장하기
       */
      transmitWorkspaceCodeSave(popupCheck) {
        if(this.missionPrefId !== null && typeof this.missionPrefId !== 'undefined') {
          this.missionPrefDummy.block = this.$refs.workspace.blocklyText;
        }
      },
      /**
       *  @DESC   미션 preference 정보 불러오기
       */
      transmitWorkspaceCodeLoad() {
        if(typeof this.missionPrefDummy.block !== 'undefined') {
          this.$refs.workspace.loadTextToBlocky(this.missionPrefDummy.block);
          alert('저장한 정보를 불러왔습니다.');
        } else {
          alert('저장된 정보가 없습니다.');
        }
      },
      /**
       *  @DESC   미션 로그 데이터 저장하기
       */
      async transmitSaveLog(cb) {

        /**
         *  미션 로그 데이터 저장 임시 비활성화
         */
        //console.log(`[CodmosMission] transmitSaveLog called!`);
        const code = await this.requestUserStudyLog(this.$refs.gamecanvas.isCleared);

        if (code === '1000') {
          cb();
        } else {
          this.$refs.studyModal.showAlertPopup({
            text: '정보가 올바르지 않습니다.'
          });
        }
      },
      /**
       *  @DESC   다음 미션 이동하기
       */
      transmitNextMission() {
        const cat4 = parseInt(this.cat4)
        if(
          !(cat4 % 5)
        ) {
          /** Map이동 : 5개 단위로 미션 완성할 경우 현재 창을 종료후 Parent window(Opener)를 Refresh 처리 */
          //this.gotoMap();

          // 놀이터 형태로 변경되면서 로직 수정(윈도우 닫기)
          window.opener.location.reload();    // 오프너(ESOP 플랫폼 웹페이지) 강제 갱신 처리
          window.close();                     // 사전교육 학습창 닫기
        } else {
          // 다음 "mission"으로 이동
          this.initMission(this.cat1, this.cat2, this.cat3, (cat4 + 1) + "", true);
        }
      },
      /**
       *  @DESC   미션 클리어 여부 체크하기
       *  @INPUT  Cat1,Cat2,Cat3,Cat4
       *  @OUTPUT Promise
       */
      requestMissionStatus(cat1,cat2,cat3,cat4) {
        return new Promise ((resolve, reject) => {
          axios.post(`${this.API_SERVER_URL}/manage/statistic/user_record`, {
            cat1: cat1,
            cat2: cat2,
            cat3: cat3,
            cat4: cat4,
          }).then((response) => {
            const {status, data} = response;
            if (status === 200 && data.hasOwnProperty('code')) {
              switch (data.code) {
                case '1000' :		// Success
                  resolve({
                    err: undefined,
                    check: data.clearCheck
                  });
                  break;
                case '2000' :		// Fail
                  alert('학습 여부를 체크하는 도중에 에러가 발생하였습니다.');
                  resolve({
                    err: true,
                    check: undefined
                  });
                  break;
                case '3000' :		// Expired
                  alert('로그인이 필요합니다.');
                  reject();
                  break;
              }
            } else {
              alert('학습 여부를 체크하는 도중에 에러가 발생하였습니다.');
              resolve({
                err: true,
                check: undefined
              });
            }
          }).catch(err => {
            alert('학습 여부를 체크하는 도중에 에러가 발생했습니다.<br>관리자에게 문의해주세요.');
            reject();
          });
        });
      },
      async checkEventEntry() {
        let bool = true;
        // if (this.cat1 === 'ESOF02') {
        //   const { data: { flag } } = await was.get(
        //       `${this.API_SERVER_URL}/manage/codmos/chck/event?${this.randomId()}`
        //   );

        //   bool = flag === '응모';
        // }

        return bool;
      },
      /**
       *  @DESC   미션초기화
       */
      async initMission(cat1, cat2, cat3, cat4, isNext) {
        this.cat1 = cat1;
        this.cat2 = cat2;
        this.cat3 = cat3;
        this.cat4 = cat4;

        const isEventEntry = await this.checkEventEntry();

        if (isEventEntry) {
          Promise.all([
          // this.requestMissionStatus(cat1, cat2, cat3, cat4),
            this.requestStudyInfo(cat1, cat2, cat3, cat4, isNext)
          ]).then(async rtnData => {
            // const [missionClearStatus, META] = rtnData;
            const [META] = rtnData;

            // if (!missionClearStatus.err) {
            //   this.clearCheck = missionClearStatus.check;
            // }

            if (!META.err) {
              const {_id: metaId, name, linkedStudyId, subContent} = META.data;

              // # 유효 데이터 존재
              if (linkedStudyId) {
                const {_id, linkedVersion, contentsData, setupData, blockData, typeGraphic} = linkedStudyId;

                const [precedence] = subContent.precedence.operand;
                if (
                  (this.cat1 === 'ESOF02'
                  || this.cat1 === 'ESOF03')
                  && precedence
                ) {
                  const [cat3, cat4] = precedence.split('_')
                  let lbcookie = document.cookie;
                  if (this.userType === 'party') lbcookie = this.getLbparty(this.cat1);

                  const res = await axios.get(
                    `${this.API_SERVER_URL}/manage/codmos/record/${this.userType}/${this.cat1}/1/${cat3}/${cat4}?${this.randomId()}`,
                    {
                      headers: {
                        lbcookie
                      }
                    });

                  if (
                    res.data.code !== '1000'
                    || !Array.isArray(res.data.docs)
                    || !res.data.docs.length
                    || !res.data.docs.some(e => e.isCleared === 1)
                  ) {
                    this.$refs.studyModal.showAlertPopup({
                      text: '이전 미션을 완료 해주세요.'
                    })
                    return;
                  }
                }
                // [T] 지우지마세요. 연동된 메타 확인
                // console.log(META);
                // console.log(_id);

                this.arrStudyInfo[cat4] = META; // [#] Cache 처리
                this.studyMetaId = metaId;
                this.studyMetaName = name;
                this.studyInfoId = _id;
                this.studyInfoVersion = linkedVersion;
                this.contentsData = contentsData;
                this.setupData = setupData;
                this.blockData = blockData;
                this.reward = subContent.reward;
                this.blckNotAssmbl = !!blockData.blckNotAssmbl;

                this.gameType = typeGraphic;

                this.$nextTick(() => {
                  this.initComponent();
                });
              }
            }
          }, err => {
            this.$refs.loading.failTask();
          });
        } else {
          this.$refs.studyModal.showAlertPopup({
            text: '이벤트 참여자만 플레이 가능합니다.'
          });
        }
      },
      /**
       *  @DESC   컴포넌트 초기화
       */
      initComponent() {
        // [#] component 초기화
        if (this.$refs.gamecanvas)
          this.$refs.gamecanvas.initCanvas(this.studyMetaName);
        if (this.$refs.workspace)
          this.$refs.workspace.initWorkspace();
      },
      /**
       *  @DESC   미션 진행 모드 온
       */
      statusOn() {
        this.isOnGame = true;
      },
      /**
       *  @DESC   미션 진행 모드 오프
       */
      statusOff() {
        this.isOnGame = false;
      },
      /**
       *  @DESC   캔버스 & 블록클리 다시 그리기
       */
      resize() {
        if (typeof this.$refs.gamecanvas !== 'undefined') {
          const innerHeight = window.innerHeight * 0.978 - 75;
          const canvasInnerHeight = innerHeight;
          const canvasInnerWidth = canvasInnerHeight * 0.85;

          // [#] 캔버스 사이즈 수정 및 재시작
          if (typeof this.$refs.gamecanvas.canvasController !== 'undefined') {
            $('#canvas').height(canvasInnerHeight);
          }

          // # Min Size
          this.$refs.gamecanvas.canvasHeight = canvasInnerHeight;
          this.$refs.gamecanvas.canvasWidth = canvasInnerWidth;

          // [#] 블록클리 사이즈 수정
          this.$nextTick(() => {
            if (typeof Blockly !== 'undefined') {
              const blocklyArea = document.getElementById('blockly-workspace');
              const blocklyDiv = document.getElementById('blocklyDiv');

              // Position blocklyDiv over blocklyArea.
              blocklyDiv.style.width = blocklyArea.offsetWidth + 'px';
              blocklyDiv.style.height = blocklyArea.offsetHeight + 'px';
              if (Blockly.getMainWorkspace()) Blockly.svgResize(Blockly.getMainWorkspace());
            }
          })

          // [#] 캔버스 및 블록클리 모두 재시작
          this.$refs.gamecanvas.restartCanvas();

          if (this.dupKey) {
            this.dupKey = false;
            window.setTimeout(() => {
              this.resize();
            }, 500)
          } else {
            this.dupKey = true;
          }
        }
      },
      /**
      * [ Function :: setBlockCount ]
      *
      * @DES :: 블록 사용 개수 / 블록 목표 개수를 모달에 전달합니다.
      * @IP1 :: null
      * @O.P :: null
      */
      setBlockCount() {
          this.$refs.gamecanvas.workCount = this.$refs.workspace.workCount
          this.$refs.gamecanvas.maxWorkCount = this.$refs.workspace.maxWorkCount
      },
      modalCallback(cb) {
        if (!cb.toString().trim().indexOf('function')) cb.call(this)
        else cb()
      },
      getLbparty(cat1) {
        let userInfo;
        switch(cat1) {
          case 'ESOF01':
            userInfo = this.getCookie('isLogin') === 'true' ? 'loginUserInfo' : 'dduNonLoginUserInfo';
            break;
          case 'ESOF02':
            userInfo = this.getCookie('isLogin') === 'true' ? 'loginUserInfo' : 'runNonLoginUserInfo';
            break;
          case 'ESOF03':
            userInfo = this.getCookie('isLogin') === 'true' ? 'loginUserInfo' : 'jbNonLoginUserInfo';
            break;
          default:
            break;
        };
        userInfo = JSON.parse(this.getCookie(userInfo) || '{}');
        return userInfo.lbparty;
      }
    },
    computed: {
      isLogin() {
        return typeof this.getCookie('userType') !== 'undefined'
      },
      cat() {
        return `${this.cat1}_${this.cat2}_${this.cat3}_${this.cat4}`
      }
    },
    watch: {
      isModalLoading(isModalLoading) {
        if (isModalLoading && typeof this.modalEvent === 'function') this.modalEvent(this.$refs.studyModal)
      }
    },
    mounted() {
      const COOKIE = this.getCookie()

      // [#] Speed & Sound 초기화
      let soundEnable = COOKIE.soundEnable
      if (typeof soundEnable !== 'undefined') {
        soundEnable = eval(soundEnable)
        this.$refs.gamecanvas.canvasDefaultMute = !soundEnable;
        this.$refs.header.soundEnable = eval(soundEnable)
      }
      this.$refs.gamecanvas.gameSpeed = this.$refs.gamecanvas.canvasDefaultSpeed = parseInt(COOKIE.gameSpeed) || 1

      if (this.isLogin === false) {
        was.post(`${this.API_SERVER_URL}/manage/codmos/user/convert`, {})
          .then(res => {
            switch (res.data.code) {
              case '1000' : {
                document.cookie = 'userType=convert; path=/; expires=Thur, 31 Dec 2099 23:59:59 UTC;'
                location.reload()
                break
              }
              case '3000' : {
                console.log('세션 만료')
              }
              case '2000' :
              default : {
                console.log('실패')
                this.$refs.studyModal.showAlertPopup()
                break
              }
            }
          })
          .catch(e => {
            console.error(e)
          })
      }
    },
    created() {
      try {
        let browserType = navigator.userAgent.toLowerCase();
        if (
          browserType.indexOf('msie 10.0') > -1 // IE 10
          || browserType.indexOf('msie 9.0') > -1 // IE 9
          || browserType.indexOf('msie 8.0') > -1 // IE 8
          || browserType.indexOf('msie 7.0') > -1 // IE 7
        ) {
          if (this.isModalLoading) {
            this.$refs.studyModal.showAlertPopup({
              text: '크롬에 최적화되어 있습니다.<br>현재 브라우저에서는 프로그램 작동이 어려울 수 있습니다.',
              btnText: '크롬 다운로드',
              btnFunc: () => {
                window.open('https://www.google.co.kr/chrome/index.html')
              }
            })
          } else {
            this.modalEvent = modal => {
              modal.showAlertPopup({
                text: '코드모스는 크롬에 최적화되어 있습니다.<br>현재 브라우저에서는<br>프로그램 작동이 어려울 수 있습니다.',
                btnText: '크롬 다운로드',
                btnFunc: () => {
                  window.open('https://www.google.co.kr/chrome/index.html')
                }
              })
            }
          }
          throw new Error('OLD IE')
        }

        this.dupKey = true;
        this.resize();

        const INIT_MISSION = () => {
          window.LC_VOLUME = this.userPrefDummy.volume;

          // [#] MetaInfo (Stage Data) 요청
          this.requestStageMeta(this.cat1, this.cat2, this.cat3, (META) => {
            this.stageSubMeta = META.subContent.objectid;

            // [#] MetaInfo (With StudyInfo) 요청
            this.initMission(this.cat1, this.cat2, this.cat3, this.cat4);
          });

          // [#] resize()
          window.addEventListener('resize', this.resize, false)

          const MD = new mobileDetect(window.navigator.userAgent)

          if (MD.tablet() !== null) {
            if (Math.abs(window.orientation) !== 90) document.body.style.overflow = 'hidden'
            window.addEventListener('orientationchange', () => {
              if (Math.abs(window.orientation) === 90) {
                document.body.style.overflow = ''
                window.scrollTo(0, 1)
                window.scrollTo(0, document.documentElement.scrollHeight)
              } else {
                document.body.style.overflow = 'hidden'
              }
            })
          }
        }

        const USER_TYPE = this.userType;
        if (typeof USER_TYPE !== 'undefined') {
          [this.cat1, this.cat2, this.cat3, this.cat4] = this.$route.params.id.split('_')

          if (USER_TYPE === 'party') {
            document.title = '이솦x코드모스 온라인 코딩파티';

            let [cat1, cat2, cat3, cat4] = [this.cat1, this.cat2, this.cat3, this.cat4]

            if (cat4 === '1') {
              INIT_MISSION()
              return
            }
            else cat4--
            let lbcookie = document.cookie;
            if (this.userType === 'party') lbcookie = this.getLbparty(cat1);

            axios.get(
              `${this.API_SERVER_URL}/manage/codmos/record/party/${cat1}/${cat2}/${cat3}/${cat4}?${this.randomId()}`,
              {
                headers: {
                  lbcookie
                }
              })
              .then(res => {
                if (
                  res.data.code !== '1000'
                  || !Array.isArray(res.data.docs)
                  || !res.data.docs.length
                  || !res.data.docs.some(e => e.isCleared === 1)
                ) throw new Error()

                INIT_MISSION();
              })
              .catch(e => {
                this.$refs.studyModal.showAlertPopup({
                  text: '이전 미션을 완료 해주세요.'
                })
              })
          } else INIT_MISSION()
        }
      } catch (err) {
        console.error(err);
      }
    }
  }
</script>

<style lang="less">
  @import '../assets/styles/workspace/web_stage.css';

  #warning-message {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.8);
    z-index: 1051;
  }
  @media only screen and (orientation:portrait){
    #wrapper { display:none; }
    #warning-message { display:block; }
  }
  @media only screen and (orientation:landscape){
    #warning-message { display:none; }
  }
</style>



// WEBPACK FOOTER //
// src/components/CodmosMission.vue